import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import auth from './auth/auth'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import suppliers from './suppliers/suppliers'
import categories from './categories/categories'
import supplierTags from './supplierTags/supplierTags'
import productTags from './productTags/productTags'
import products from './products/products'
import pos from './pos/pos'
import branches from './branches/branches'
import projects from './projects/projects'
import quotes from './quotes/quotes'
import incomes from './incomes/incomes'
import expenses from './expenses/expenses'
import groupedExpenses from './groupedExpenses/groupedExpenses'
import shippings from './shippings/shippings'
import customers from './customers/customers'
import billing from './billing/billing'
import users from './users/users'
import settings from './settings/settings'
import notifications from './notifications/notifications'
import memberships from './memberships/memberships'
import loginSlides from './loginSlides/loginSlides'
import legal from './legal/legal'
import userNotifications from './userNotifications/userNotifications'
import purchaseOrders from './purchaseOrders/purchaseOrders'
import wallet from './wallet/wallet'
import finance from './finance/finance'
import warehouse from './warehouse/warehouse'
import suppliesExplosion from './suppliesExplosion/suppliesExplosion'
import tickets from './tickets/tickets'
import materialSuggestions from './materialSuggestions/materialSuggestions'
import quoteNotes from './quoteNotes/quoteNotes'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    suppliers,
    categories,
    supplierTags,
    productTags,
    products,
    pos,
    branches,
    auth,
    projects,
    quotes,
    expenses,
    incomes,
    groupedExpenses,
    shippings,
    customers,
    billing,
    users,
    settings,
    notifications,
    memberships,
    loginSlides,
    legal,
    userNotifications,
    purchaseOrders,
    wallet,
    finance,
    warehouse,
    suppliesExplosion,
    tickets,
    materialSuggestions,
    quoteNotes,
  },
  state: {
    apiUrl: process.env.VUE_APP_API_URL,
  },
  strict: process.env.DEV,
})
